import TheMainLayout from '@/components/TheMainLayout/TheMainLayout'
import PlansRoutesPath from '@/views/plan/router'
import SitesRoutesPath from '@/views/site/router'
import FaqRoutesPath from '@/views/faq/router'
import PageNotFound from '@/views/static/PageNotFound'
import { shouldBeAuthenticate } from '@/router/filters'
import VueCookies from 'vue-cookies'

const routes = [
  {
    path: '/logout',
    beforeEnter: async (to, from, next) => {
      VueCookies.remove(
        'wordpress-panel-authorization',
        null,
        process.env.VUE_APP_DOMAIN
      )
      window.open(
        `${process.env.VUE_APP_API_BASE_URL}/logout`,
        '_self'
      )
    }
  },
  {
    path: '/',
    component: TheMainLayout,
    children: [
      ...PlansRoutesPath,
      ...SitesRoutesPath,
      ...FaqRoutesPath,
      {
        path: '*',
        name: 'not-found',
        component: PageNotFound,
        title: 'static.notFound.title'
      }
    ],
    beforeEnter: shouldBeAuthenticate
  }
]

export default routes
